/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkPickedUpRequest
 */
export interface MarkPickedUpRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkPickedUpRequest
     */
    shipmentId: string;
}

/**
 * Check if a given object implements the MarkPickedUpRequest interface.
 */
export function instanceOfMarkPickedUpRequest(value: object): value is MarkPickedUpRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function MarkPickedUpRequestFromJSON(json: any): MarkPickedUpRequest {
    return MarkPickedUpRequestFromJSONTyped(json, false);
}

export function MarkPickedUpRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkPickedUpRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
    };
}

  export function MarkPickedUpRequestToJSON(json: any): MarkPickedUpRequest {
      return MarkPickedUpRequestToJSONTyped(json, false);
  }

  export function MarkPickedUpRequestToJSONTyped(value?: MarkPickedUpRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
    };
}

